module.exports = __webpack_public_path__ + "static/media/Montserrat-MediumItalic.ad732b72.woff";